import { createAsyncThunk } from "@reduxjs/toolkit";
import { db } from "../../../firebase/config";
import firebase from "firebase";
import { TalesFaq } from "../../../utils/types/TalesFaq";
import FieldValue = firebase.firestore.FieldValue;

export const addFaq = createAsyncThunk("faq/add", async (faq: TalesFaq) => {
  try {
    return await db.collection("faq").add({
      ...faq,
      show: `${faq.show}` === "true",
      creationDate: FieldValue.serverTimestamp(),
    });
  } catch (e: any) {
    console.log(e);

    return Promise.reject(`Faq non aggiunta, ${e.message}`);
  }
});
